import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import ScrollReveal from "../Components/ScrollReveal";

const occasions = ["Birthdays", "Holidays", "Anniversaries", "Corporate", "Just Because"];

const GC = () => {
  const [iframeReady, setIframeReady] = useState(false);
  const current = new Date();

  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: "Gift Certificate",
    description: "American Legacy Tour gift certificates are the perfect gift for any holiday or occasion.",
    offers: {
      "@type": "Offer",
      url: "https://www.americanlegacytours.com/gift-certificates",
      price: "35",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      priceValidUntil: "12/31/" + current.getFullYear(),
    },
  };

  return (
    <>
      <PageSEO
        title="Gift Certificates | American Legacy Tours"
        description="Give the gift of adventure with American Legacy Tours gift certificates. Any dollar amount, never expires. Perfect for birthdays, holidays &amp; any occasion."
        path="/gift-certificates"
        type="product"
        schema={schema}
      />

      {/* --- Header --- */}
      <div style={{
        position: "relative",
        background: "var(--brand-dark)",
        backgroundImage: "url('https://res.cloudinary.com/american-legacy-tours/image/upload/c_fill,h_500,w_1800/f_auto,q_auto/img/home/slider/slider-02')",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        padding: "48px 0 40px",
      }}>
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.55) 100%)", zIndex: 0 }} />
        <Container style={{ position: "relative", zIndex: 1 }}>
          <h1 style={{ color: "#fff", fontWeight: 800, fontSize: "clamp(1.6rem, 4vw, 2.2rem)", margin: "0 0 10px", lineHeight: 1.2 }}>
            Gift Certificates
          </h1>
          <p style={{ color: "rgba(255,255,255,0.6)", margin: "0 0 20px", maxWidth: 520, fontSize: "0.95rem" }}>
            Give the gift of historically entertaining tours — perfect for any occasion.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {occasions.map((o) => (
              <span key={o} style={{
                background: "rgba(255,255,255,0.1)",
                color: "rgba(255,255,255,0.8)",
                fontSize: "0.75rem",
                fontWeight: 600,
                padding: "4px 12px",
                borderRadius: 100,
                border: "1px solid rgba(255,255,255,0.15)",
              }}>
                {o}
              </span>
            ))}
          </div>
        </Container>
      </div>

      {/* --- Body --- */}
      <section style={{ background: "#f8f7f4", padding: "48px 0 72px" }}>
        <Container>
          <Row>

            {/* --- Sidebar --- */}
            <Col md={4} lg={3} className="mb-4 mb-md-0">
              <ScrollReveal direction="left">
                <div style={{
                  background: "#fff",
                  borderRadius: 8,
                  overflow: "hidden",
                  boxShadow: "var(--shadow-card)",
                  position: "sticky",
                  top: 100,
                }}>
                  <div style={{ background: "var(--brand-orange)", padding: "20px 24px" }}>
                    <div style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px", color: "rgba(0,0,0,0.6)", marginBottom: 4 }}>
                      Gift Certificate
                    </div>
                    <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#000", lineHeight: 1.2 }}>
                      Any Dollar Amount
                    </div>
                    <div style={{ fontSize: "0.78rem", color: "rgba(0,0,0,0.55)", marginTop: 4 }}>
                      you choose the value
                    </div>
                  </div>

                  <div style={{ padding: "20px 24px" }}>
                    <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px", fontSize: "0.88rem", color: "#555" }}>
                      {[
                        "Valid for any American Legacy Tour",
                        "Never expires",
                        "Easy to purchase &amp; send",
                        "Redeemable online at checkout",
                      ].map((item) => (
                        <li key={item} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 10 }}>
                          <span style={{ color: "var(--brand-orange)", fontWeight: 700, flexShrink: 0 }}>&#10003;</span>
                          <span dangerouslySetInnerHTML={{ __html: item }} />
                        </li>
                      ))}
                    </ul>

                    <hr style={{ margin: "0 0 16px", borderColor: "#f0f0f0" }} />

                    <p style={{ fontSize: "0.82rem", color: "#888", margin: 0 }}>
                      Questions? Call us at{" "}
                      <a href="tel:8599518560" style={{ fontWeight: 600, color: "var(--brand-orange)", textDecoration: "none", whiteSpace: "nowrap" }}>
                        (859) 951-8560
                      </a>
                    </p>
                  </div>
                </div>
              </ScrollReveal>
            </Col>

            {/* --- Gift certificate iframe --- */}
            <Col md={8} lg={9}>
              <ScrollReveal direction="right" delay={80}>
                <div style={{ background: "#fff", borderRadius: 8, overflow: "hidden", boxShadow: "var(--shadow-card)", position: "relative" }}>
                  {!iframeReady && (
                    <div style={{ padding: "60px 0", textAlign: "center" }}>
                      <Spinner animation="border" role="status" style={{ color: "var(--brand-orange)", width: 40, height: 40 }}>
                        <span className="sr-only">Loading...</span>
                      </Spinner>
                      <p style={{ color: "#999", marginTop: 16, fontSize: "0.88rem" }}>Loading gift certificates…</p>
                    </div>
                  )}
                  <iframe
                    title="Gift Certificates"
                    src="https://americanlegacytours.thundertix.com/gift_certificates/53"
                    width="100%"
                    height="700"
                    frameBorder="0"
                    scrolling="auto"
                    onLoad={() => setIframeReady(true)}
                    style={{ display: iframeReady ? "block" : "none" }}
                  />
                </div>
              </ScrollReveal>
            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
};

export default GC;
